import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';

// TODO: Consider adding a mobile menu close animation
// TODO: Add aria-labels for accessibility improvements

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  // DEBUG: Track scroll state changes
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        console.log('[Header] Scroll state changed:', { scrollY: window.scrollY, isScrolled });
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Check initial scroll position
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <header>
      <Navbar
        expand="lg"
        className={`py-3 ${scrolled ? 'scrolled' : ''}`}
        fixed="top"
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <img
              src="/assets/dd_logo_transparent.png"
              alt="DD Construction Logo"
              height="60"
              className="me-2"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="ms-auto">
              <Nav.Link as={NavLink} to="/" end>
                Home
              </Nav.Link>
              <Nav.Link as={NavLink} to="/gallery">
                Gallery
              </Nav.Link>
              <Nav.Link as={NavLink} to="/contact">
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/* Spacer to prevent content from hiding under fixed navbar */}
      <div style={{ height: '80px' }} />
    </header>
  );
};

export default Header;
